import { Box, Grid2, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import jobService from "../api/services/job-service";
import MrrDocumentsTable from "../components/mrr-documents-table";
import { showErrorToast } from "../helpers/utils";
import unauth from "../images/unauth.png";
import { PermissionsContext } from "../permission-context";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import accountConfig from "../config/account-config.json";
import { ReactComponent as RefreshIcon } from "../Icons/vuesax/refresh.svg";
import { Button, Tooltip } from "antd";

function MrrDocuments() {
  const { loading, error, hasPermission } = useContext(PermissionsContext);
  const [records, setRecords] = useState(null);
  const [account, setAccount] = useState("WCARNEY");
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    fetchMrrAccounts();
  }, []);
  
  useEffect(() => {
    fetchMrrDocuments(account); 
  }, [account]);

  const fetchMrrAccounts = async () => {
    const accounts = accountConfig["mrr-accounts"];
    setAccounts(accounts);
  };

  const fetchMrrDocuments = async (account) => {
    try {
      const res = await jobService.getMrrDocuments(account);
      if (res.status === 200 || res.status === 201) {
        setRecords(res.data);
      } else {
        showErrorToast("Unable to fetch MRR documents. Please check your connection or try again later.");
        setRecords([]);
      }
    } catch (error) {
      showErrorToast("Error Fetching MRR documents:" + error);
    }
  };

  const handleRemovePatient = (vfId, jobId) => {
    setRecords((prev) => prev.filter((r) => !(r.vfId === vfId && r.jobId === jobId)));
  };

  return (
    <>
      {!loading && !error && hasPermission("MER") && (
        <Box style={{ marginRight: "1%", marginLeft: "2%" }}>
          <Grid2
            container
            justifyContent='space-between'
            alignItems='center'
            sx={{
              borderBottom: 1,
              borderColor: "#dfdfdf",
              marginTop: 1.5,
              marginBottom: "12px"
            }}>
            <Grid2>
              <Typography
                gutterBottom
                fontWeight='700'
                lineHeight={"31.25px"}
                fontSize={"24px"}
                fontStyle={"DM Sans"}>
                MRR Documents
              </Typography>
            </Grid2>
          </Grid2>
          <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "5px", margin: "15px 0" }}>
            <Tooltip title="Refresh">
              <Button onClick={() => fetchMrrDocuments(account)} type="link">
                <RefreshIcon width="24px" height="24px" />
              </Button>
            </Tooltip>
            <Autocomplete
              disableClearable
              options={accounts || []}
              value={account || null}
              onChange={(event, newValue) => {
                setAccount(newValue || "");
              }}
              sx={{
                width: 180,
                marginRight: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  padding: "0 8px",
                  fontSize: "14px",
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Account"
                />
              )}
              slotProps={{
                listbox: {
                  sx: {
                    maxHeight: 200,
                    fontSize: "14px",
                  }
                }
              }}
            />
          </Box>
          <Grid2 size={12}>
            <MrrDocumentsTable data={records} onRemovePatient={handleRemovePatient} />
          </Grid2>
        </Box>
      )}
      {!loading && !error && !hasPermission("MER") && (
        <Box
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "90vh",
          }}>
          <img src={unauth} alt='UnAuthorized' style={{ maxWidth: "100%", maxHeight: "100%" }} />
        </Box>
      )}
    </>
  );
}
export default MrrDocuments;
